export default "__VITE_ASSET__fELunJC___"